export const MollieIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="24"
      viewBox="0 0 82 24"
      fill="none"
      {...props}
    >
      <path
        d="M34.3586 7.83789C29.8972 7.83789 26.2773 11.4675 26.2773 15.9191C26.2773 20.3708 29.9069 24.0004 34.3586 24.0004C38.8102 24.0004 42.4398 20.3708 42.4398 15.9191C42.4398 11.4675 38.82 7.83789 34.3586 7.83789ZM34.3586 20.1758C32.0158 20.1758 30.1084 18.2684 30.1084 15.9256C30.1084 13.5828 32.0158 11.6754 34.3586 11.6754C36.7014 11.6754 38.6088 13.5828 38.6088 15.9256C38.6088 18.2684 36.7014 20.1758 34.3586 20.1758Z"
        fill="black"
      />
      <path
        d="M61.2413 5.03981C62.632 5.03981 63.7628 3.91227 63.7628 2.51828C63.7628 1.12429 62.632 0 61.2413 0C59.8505 0 58.7197 1.12754 58.7197 2.52153C58.7197 3.91552 59.8505 5.03981 61.2413 5.03981Z"
        fill="black"
      />
      <path
        d="M17.8587 7.84435C17.6474 7.82811 17.446 7.81836 17.238 7.81836C15.2884 7.81836 13.4395 8.61771 12.1137 10.0279C10.788 8.62421 8.94557 7.81836 7.01543 7.81836C3.14866 7.82161 0 10.9605 0 14.8273V23.6721H3.77904V14.9345C3.77904 13.3293 5.09829 11.8509 6.6515 11.6916C6.76198 11.6819 6.86921 11.6754 6.96994 11.6754C8.71812 11.6754 10.1446 13.1019 10.1543 14.85V23.6689H14.0179V14.9183C14.0179 13.3228 15.3274 11.8444 16.8903 11.6851C17.0008 11.6754 17.108 11.6689 17.2088 11.6689C18.9569 11.6689 20.3932 13.0889 20.3997 14.8273V23.6721H24.2632V14.9345C24.2632 13.1636 23.6068 11.4544 22.424 10.1384C21.2445 8.81267 19.6231 7.99708 17.8587 7.84435Z"
        fill="black"
      />
      <path
        d="M48.387 0.376953H44.5234V23.6881H48.387V0.376953ZM55.7826 0.376953H51.9191V23.6881H55.7826V0.376953ZM63.1749 8.22423H59.3114V23.6816H63.1749V8.22423Z"
        fill="black"
      />
      <path
        d="M81.2351 15.5581C81.2351 13.5077 80.4358 11.5776 78.9931 10.1056C77.5406 8.63689 75.6234 7.82129 73.5828 7.82129H73.4821C71.3667 7.84728 69.3651 8.68563 67.8704 10.1901C66.3757 11.6946 65.5341 13.6832 65.5113 15.8083C65.4853 17.9756 66.3172 20.026 67.8541 21.5792C69.3911 23.1324 71.4252 23.9903 73.5926 23.9903H73.6023C76.4423 23.9903 79.1035 22.4695 80.5593 20.026L80.7445 19.7141L77.5536 18.1446L77.3944 18.4046C76.5885 19.7238 75.2043 20.5037 73.6673 20.5037C71.7014 20.5037 70.0052 19.1942 69.4821 17.329H81.2351V15.5581ZM73.4301 11.3306C75.1945 11.3306 76.7737 12.4907 77.3294 14.1349H69.5406C70.0865 12.4907 71.6657 11.3306 73.4301 11.3306Z"
        fill="black"
      />
    </svg>
  );
};
